import classNames from "classnames";

export function Loading({ className }: { className?: string }) {
  return (
    <div className="w-full h-full flex justify-center items-center">
      <div
        className={classNames(
          "animate-spin rounded-full h-32 w-32 border-b-2 border-primary-500",
          className,
        )}
      ></div>
    </div>
  );
}
